import React from "react";
import { View } from "react-native";
import { useTheme } from "../hooks/use-theme";
import { BasquiatPaddingProps, useUnitPropsConverter } from "./units";

const Separator: React.FC<BasquiatPaddingProps> = ({ ...marginProps }) => {
    const { colors } = useTheme();
    const propsConverter = useUnitPropsConverter();
    const marginStyle = propsConverter(marginProps, "margin");
    return (
        <View
            style={[
                { flex: 1, height: 1, backgroundColor: colors.accentLighter, alignSelf: "stretch" },
                marginStyle,
            ]}
        />
    );
};

export default Separator;
